// type LazyImageProps = React.ImgHTMLAttributes<HTMLImageElement>;
import { Image } from 'react-bootstrap';

import type { ImageProps } from 'react-bootstrap';
export default function LazyImage(props: ImageProps) {
  return <Image loading="lazy" decoding="async" {...props} />;
}
